export const feedPreferencesHelpText = `

# Feed Preferences

The Feed Preferenes allow you to tune the filtering algorithm to your liking. In general the default settings are good, but you can change them to your liking.

## Fire Hose

If checked you will see every author and their content. This overrides all other settings but the 'Tolerance for Authors you dislike' setting.

## Tolerance for Authors you dislike

This setting allows you to filter out authors you dislike, as determined by your ratings of their post and comments. If your tolerance is low, you won't see that author's post after disliking them a few times.
If your tolerance is high, you will need to dislike them many times before you stop seeing their posts.

If you don't want to filter out any authors based on your dislikes, set this to 'Disabled'.

## Volume Preference

This is a hint to the algorithm to give it a sense of how much stuff you want to see. If your preferences aren't generating enough new content, 
the algorithm will mix in content that is highly rated. If you feel like you are seeing too much content, set this to low. If you like to see a lot of new stuff from people you might
not know, set this to high.
## Author Preferences

These three settings allow you to indicate a preference for people you like 'Friends', people who are liked by people you like 'Friends of Friends',
and people who are popular 'Popular Authors'. Popular authors are determined by the number of likes they have received on their posts using an algorithm
that prefers long term popularity over short term popularity.


`;
